import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class ManageGuestDetailsFilterButtons extends Component {
  static propTypes = {
    showAllFilters: PropTypes.func.isRequired,
    downloadAllKeyinstructionsLink: PropTypes.bool.optional,
    manageGuestDetailsLink: PropTypes.bool.optional,
  }

  showAllFilters = () => this.props.showAllFilters()

  render () {
    const addMarginsToButton = {
          margin: '2px',
    };

    return (

        <div className="stage-actions">
            <div className="stage-actions__buttons">
                <button className='btn btn--primary' style={addMarginsToButton} onClick={this.showAllFilters}>
                    All filters
                </button>
                <div className="divider"/>
                <button className='btn btn--primary' style={addMarginsToButton} onClick={()=> window.open(this.props.downloadAllKeyinstructionsLink)}>
                    Download All Key Instructions
                </button>
                <div className="divider"/>
                <button className='btn btn--primary' style={addMarginsToButton} id="extra-services-request-btn">
                    Akommo Extra Services
                </button>

            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageGuestDetailsFilterButtons.js